module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iqAVg6/tc-custom/9781426871627.jpg?1718282660239",
      "alt": "This image is the cover for the book Safe by His Side, Colby Agency"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Safe by His Side, Colby Agency\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("No one could find special agent Jack Raine if he didn't want to be found. So who was the beautiful amnesiac on his doorstep, and how had she gotten to his hideaway? When a killer soon followed, Jack suspected a trap--so he took the lady and ran..."), _c('br'), _c('br'), _vm._v("\"Kate\" couldn't remember her own name, but she wanted the strong and silent Jack Raine the moment she saw him. Even as a slow heat burned between them, Kate knew she risked falling for this stranger who'd saved her life--a man her flashes of memory suggested she might have been sent to capture...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debra Webb\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("DEBRA WEBB is the award winning, USA Today bestselling author of more than 170 novels, including reader favorites the Finley O'Sullivan series, the Colby Agency, and the Lookout Mountain Mystery series. With more than four million books sold in numerous languages and countries, Debra's love of storytelling goes back to her childhood on a farm in Alabama. Visit Debra at www.DebraWebb.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0